import { SurfaceIdentitySurface } from "@redotech/cockroachdb-codegen/tables/surface-identity/surface-identity-surface";
import * as z from "zod";

export const verifySurfaceIdentity = {
  name: "verifySurfaceIdentity" as const,
  input: z.object({
    token: z.string().min(1),
    confirmedLink: z.boolean().optional(),
  }),
  // `ok` is not a unique discriminator: confirm and terminal failures both
  // return ok=false. A union keeps those shapes distinct without colliding.
  output: z.union([
    z.object({
      ok: z.literal(true),
      surface: z.enum(SurfaceIdentitySurface),
      surfaceKey: z.string(),
    }),
    z.object({
      ok: z.literal(false),
      reason: z.literal("confirm_address_link"),
      claimedAddress: z.string(),
    }),
    z.object({
      ok: z.literal(false),
      reason: z.literal("confirm_surface_link"),
      surface: z.enum(SurfaceIdentitySurface),
      surfaceKey: z.string(),
    }),
    z.object({
      ok: z.literal(false),
      reason: z.enum(["invalid", "expired", "already_used"]),
    }),
  ]),
};
